import { t } from 'i18next';
import {
  GET_GEOFENCE_LOCATIONS,
  GET_GEOFENCE_LOCATIONS_SUCCESS,
  GET_GEOFENCE_LOCATIONS_FAILURE,
  DELETE_GEOFENCE_LOCATION,
  DELETE_GEOFENCE_LOCATION_SUCCESS,
  DELETE_GEOFENCE_LOCATION_FAILURE,
  ADD_GEOFENCE_LOCATION,
  ADD_GEOFENCE_LOCATION_SUCCESS,
  ADD_GEOFENCE_LOCATION_FAILURE,
  CLEAR_CREATED_GEOFENCE_LOCATION,
  LOGIN_PROFILE_CREATED_RESET,
  UPDATE_GEOFENCE_LOCATION,
  UPDATE_GEOFENCE_LOCATION_SUCCESS,
  UPDATE_GEOFENCE_LOCATION_FAILURE,
} from '../../modules/constants';
import { createNotification } from "../../modules/notificationManager";

// Get geofence locations list
export const getGeofenceLocationsRequest = (state, action) => {
  return {
    ...state,
    loading: true,
    error: null,
  };
};

export const getGeofenceLocationsRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      loading: false,
      geofenceLocations: data.data,
    };
  }
  return {
    ...state,
    loading: false,
    geofenceLocations: [],
  };
};

export const getGeofenceLocationsRequestFailure = (state, action) => {
  return {
    ...state,
    loading: false,
    error: action.payload,
    geofenceLocations: [],
  };
};

// Delete geofence location
export const deleteGeofenceLocationRequest = (state, action) => {
  return {
    ...state,
    deleteGeofenceLocationLoading: true,
    deleteError: null,
  };
};

export const deleteGeofenceLocationRequestSuccess = (state, action) => {
  const {
    payload: { data, locationId },
  } = action;
  if (data && (data.status === 200 || data.status === 204)) {
    createNotification('success', t('geofence_location_deleted_successfully'), 2000);
    const currentList = JSON.parse(JSON.stringify(state.geofenceLocations));
    return {
      ...state,
      deleteGeofenceLocationLoading: false,
      geofenceLocations: currentList.filter(location => location.id !== locationId),
    };
  }
  return {
    ...state,
    deleteGeofenceLocationLoading: false,
  };
};

export const deleteGeofenceLocationRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  let errorMessage = 'Failed to delete location. Please try again.';
  if (response?.data?.detail) {
    errorMessage = response.data.detail;
  }
  createNotification('error', errorMessage, 3000);
  return {
    ...state,
    deleteGeofenceLocationLoading: false,
    deleteError: errorMessage,
  };
};

// Add geofence location
export const addGeofenceLocationRequest = (state, action) => {
  return {
    ...state,
    addGeofenceLocationLoading: true,
    addError: null,
  };
};

export const addGeofenceLocationRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 201) {
    createNotification('success', t('geofence_location_added_successfully'), 2000);
    const currentList = JSON.parse(JSON.stringify(state.geofenceLocations));
    return {
      ...state,
      addGeofenceLocationLoading: false,
      createdGeofenceLocationInfo: data.data,
      geofenceLocations: [data.data, ...currentList],
    };
  }
  return {
    ...state,
    addGeofenceLocationLoading: false,
    createdGeofenceLocationInfo: null,
  };
};

export const addGeofenceLocationRequestFailure = (state, action) => {
  const {
    payload: { response },
  } = action;
  let errorMessage = 'Failed to add location. Please try again.';
  if (response?.data?.detail) {
    errorMessage = response.data.detail;
  }
  createNotification('error', errorMessage, 3000);
  return {
    ...state,
    addGeofenceLocationLoading: false,
    addError: errorMessage,
  };
};

// Clear created geofence location
export const clearCreatedGeofenceLocationRequest = (state, action) => {
  return {
    ...state,
    createdGeofenceLocationInfo: null,
  };
};

// Update geofence location
export const updateGeofenceLocationRequest = (state, action) => {
  return {
    ...state,
    updateGeofenceLocationLoading: true,
    updateError: null,
  };
};

export const updateGeofenceLocationRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data && data.status === 200) {
    createNotification('success', t('geofence_location_updated_successfully'), 2000);
    const currentList = JSON.parse(JSON.stringify(state.geofenceLocations));
    return {
      ...state,
      updateGeofenceLocationLoading: false,
      geofenceLocations: currentList.map(location => location.id === data.data.id ? data.data : location),
    };
  }
  return {
    ...state,
    updateGeofenceLocationLoading: false,
  };
};

export const updateGeofenceLocationRequestFailure = (state, action) => {
  return {
    ...state,
    updateGeofenceLocationLoading: false,
    updateError: action.payload,
  };
};




// Clear state on logout
export const handleLogoutRequest = (state, action) => {
  return {
    ...initialState,
  };
};

// Action Handlers mapping
const ACTION_HANDLERS = {
  [GET_GEOFENCE_LOCATIONS]: getGeofenceLocationsRequest,
  [GET_GEOFENCE_LOCATIONS_SUCCESS]: getGeofenceLocationsRequestSuccess,
  [GET_GEOFENCE_LOCATIONS_FAILURE]: getGeofenceLocationsRequestFailure,

  [DELETE_GEOFENCE_LOCATION]: deleteGeofenceLocationRequest,
  [DELETE_GEOFENCE_LOCATION_SUCCESS]: deleteGeofenceLocationRequestSuccess,
  [DELETE_GEOFENCE_LOCATION_FAILURE]: deleteGeofenceLocationRequestFailure,

  [ADD_GEOFENCE_LOCATION]: addGeofenceLocationRequest,
  [ADD_GEOFENCE_LOCATION_SUCCESS]: addGeofenceLocationRequestSuccess,
  [ADD_GEOFENCE_LOCATION_FAILURE]: addGeofenceLocationRequestFailure,

  [UPDATE_GEOFENCE_LOCATION]: updateGeofenceLocationRequest,
  [UPDATE_GEOFENCE_LOCATION_SUCCESS]: updateGeofenceLocationRequestSuccess,
  [UPDATE_GEOFENCE_LOCATION_FAILURE]: updateGeofenceLocationRequestFailure,

  [CLEAR_CREATED_GEOFENCE_LOCATION]: clearCreatedGeofenceLocationRequest,
  [LOGIN_PROFILE_CREATED_RESET]: handleLogoutRequest,
};

// Initial state
const initialState = {
  geofenceLocations: [],
  loading: false,
  error: null,
  deleteGeofenceLocationLoading: false,
  deleteError: null,
  addGeofenceLocationLoading: false,
  addError: null,
  createdGeofenceLocationInfo: null,
};

// Main reducer function
export default function geofenceLocationsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}